import React from "react";
import BulletItem from "./_bulletItem";
export default function AdultsBetterHealth(){
    // const refArray = []
    function createBulletList(list) {
        return(
            <BulletItem
            id={list.id}
            // ref={e => refArray.push(e.current)}
            text={list.text}
            ></BulletItem>
            );
        }
    const adultProductUsesList=[
        {
            id:"adultProductUsesList_1",
            text:'Better performance and mental health',
        },
        {
            id:"adultProductUsesList_2",
            text:'Balanced hormones and immunity',
        },
        {
            id:"adultProductUsesList_3",
            text:'Delay or prevent mid-life illness',
        },
        {
            id:"adultProductUsesList_4",
            text:'Slow down aging',
        },
        {
            id:"adultProductUsesList_5",
            text:'Improved metabolism and heart health',
        },
        {
            id:"adultProductUsesList_6",
            text:'Enhanced physical fitness and productivity ',
        },
        {
            id:"adultProductUsesList_7",
            text:'Prevent nutrient deficiency ',
        }
    ];
    
    return (
        <section className="better_health_section">
            <div className="better_health_container">
                <h3 className="better_health_container__heading">Better health starts here</h3>
                <div className="better_health_container__list">
                {adultProductUsesList.map(createBulletList)}
                </div>
            </div>
        </section>
    );
}